import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups/withIssue`;

export interface CreateClaimGroupWithIssueForOwnerCommandArgs {
  ownerId: string;
  ownerProductIds: string[];
  issueId: string;
  origin: string;
}

export const createClaimGroupWithIssueForOwnerRequest = ({
  ownerId,
  ownerProductIds,
  issueId,
  origin,
}: CreateClaimGroupWithIssueForOwnerCommandArgs): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { ownerId, ownerProductIds, issueId, origin },
  },
});

export const createClaimGroupWithIssueForOwnerCommand = async (
  args: CreateClaimGroupWithIssueForOwnerCommandArgs,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<string>>(
      createClaimGroupWithIssueForOwnerRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
